import { createGlobalStyle } from 'styled-components';
import { colors } from './colors';

export const theme = {
  ...colors,
};

const GlobalStyle = createGlobalStyle`
	/* html, body {
		font-size: 14px;
		font-family:  'Questrial','Poppins','sofia-pro', sans-serif;
		background-color: white;
		scrollbar-width: thin;
    color: #666;
    margin: 0;
	} */

		/* Make clicks pass-through */
#nprogress {
  pointer-events: none;
}

#nprogress .bar {
  background: ${colors.red[700]};

  position: fixed;
  z-index: 1031;
  top: 63px;
  left: 0;

  width: 100%;
  height: 3px;
}

/* Fancy blur effect */
#nprogress .peg {
  display: block;
  position: absolute;
  right: 0px;
  width: 100px;
  height: 100%;
  box-shadow: 0 0 10px ${colors.primary.main}, 0 0 5px ${colors.primary.main};
  opacity: 1.0;

  -webkit-transform: rotate(3deg) translate(0px, -4px);
      -ms-transform: rotate(3deg) translate(0px, -4px);
          transform: rotate(3deg) translate(0px, -4px);
}

/* Remove these to get rid of the spinner */
#nprogress .spinner {
  display: block;
  position: fixed;
  z-index: 1031;
  top: 79px;
  right: 15px;
}

#nprogress .spinner-icon {
  width: 18px;
  height: 18px;
  box-sizing: border-box;

  border: solid 2px transparent;
  border-top-color: ${colors.red[700]};
  border-left-color: ${colors.red[700]};
  border-radius: 50%;

  -webkit-animation: nprogress-spinner 400ms linear infinite;
          animation: nprogress-spinner 400ms linear infinite;
}

.nprogress-custom-parent {
  overflow: hidden;
  position: relative;
}

.nprogress-custom-parent #nprogress .spinner,
.nprogress-custom-parent #nprogress .bar {
  position: absolute;
}

@-webkit-keyframes nprogress-spinner {
  0%   { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}
@keyframes nprogress-spinner {
  0%   { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

pre {
  white-space: pre-wrap;
  word-wrap: normal;
  word-break: keep-all;
  font-family:  'Source Sans Pro','Poppins', 'BlinkMacSystemFont';
  font-size: 14px;
}

`;

export default GlobalStyle;
// This file is unused now
